//import { apiGet, apiDelete } from './apiWrapper';
//import { apiGet, apiDelete } from '../services/api';
import { apiGet, apiDelete } from "./api/apiMethods";

import { calculateStatus, sortTasks } from "../utils/taskStatus";

export const fetchTasks = async () => {
  const response = await apiGet("/TaskTracking/GetAll");
  return processTasks(response.data);
};

export const fetchDashBoardSummary = async () => {
  const response = await apiGet("/TaskTracking/GetTaskDashboardSummary");
  return response;
};

export const deleteTask = async (taskId) => {
  const response = await apiDelete(`/TaskTracking/Delete/${taskId}`);
  if (!response?.isSuccess) {
    throw new Error(response?.message || "Failed to delete task");
  }
  return response;
};

const processTasks = (tasks) => {
  return tasks
    .map((task) => ({
      ...task,
      status: calculateStatus(task),
    }))
    .sort(sortTasks);
};
